import { BrowserRouter as Router } from "react-router-dom";
import "./style/App.css";
import WebLayout from "./components/layouts/WebLayout";
import { ThemeProvider } from "./context/ThemeContext";
import { SocketProvider } from "./context/SocketContext";
import MainRouter from "./routes/MainRouter";
import AuthInitializer from "./components/AuthInitializer";

function App() {

    return (
        <ThemeProvider>
            <Router>
                <AuthInitializer>
                    <SocketProvider>
                        <WebLayout>
                            <MainRouter />
                        </WebLayout>
                    </SocketProvider>
                </AuthInitializer>
            </Router>
        </ThemeProvider>
    );
}

export default App;
